import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { Icon, IconName } from '@frontend/icons';
import { Button, PopoverMenu, PopoverMenuItem, usePopoverMenu } from '@frontend/design-system';
import { useBulkNavigator } from '../../hooks/use-bulk-navigator';

type ActionsMenuOptions = {
  icon: IconName;
  label: string;
  onClick: () => void;
  trackingId: string;
};

type Props = {
  trackingIdPrefix: string;
};

export const MultiCampaignButton = ({ trackingIdPrefix }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const navigateToEmail = useBulkNavigator(CampaignType.EMAIL);
  const navigateToText = useBulkNavigator(CampaignType.SMS);

  const actions: ActionsMenuOptions[] = [
    {
      icon: 'cell-phone-small',
      label: t('New Text Campaign'),
      onClick: () => navigateToText.editor(), // TODO: Do a 10DLC check here. Expand the original single location 10DLC check to multi-location.
      trackingId: `${trackingIdPrefix}-new-text-campaign-popover-btn`,
    },
    {
      icon: 'email-small',
      label: t('New Email Campaign'),
      onClick: () => navigateToEmail.editor(),
      trackingId: `${trackingIdPrefix}-new-email-campaign-popover-btn`,
    },
  ];

  const { getTriggerProps, getMenuProps, getItemProps, open } = usePopoverMenu({
    placement: 'bottom-end',
    middlewareOptions: {
      offset: {
        mainAxis: 0,
        alignmentAxis: 0,
      },
    },
  });

  return (
    <>
      <Button
        {...getTriggerProps()}
        onClick={open}
        size='large'
        trackingId={`${trackingIdPrefix}-new-campaign-popover-trigger-btn`}
        variant='primary'
      >
        {t('New Campaign')}
      </Button>
      <PopoverMenu {...getMenuProps()}>
        {actions.map(({ icon, label, onClick, trackingId }, index) => (
          <PopoverMenuItem {...getItemProps({ onClick, index })} key={label} trackingId={trackingId}>
            <>
              <Icon name={icon} />
              {label}
            </>
          </PopoverMenuItem>
        ))}
      </PopoverMenu>
    </>
  );
};
